/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ManualRouteImport } from './routes/manual'
import { Route as LinhaDoTempoRouteImport } from './routes/linha-do-tempo'
import { Route as AlbumRouteImport } from './routes/album'
import { Route as IndexRouteImport } from './routes/index'

const ManualRoute = ManualRouteImport.update({
  id: '/manual',
  path: '/manual',
  getParentRoute: () => rootRouteImport,
} as any)
const LinhaDoTempoRoute = LinhaDoTempoRouteImport.update({
  id: '/linha-do-tempo',
  path: '/linha-do-tempo',
  getParentRoute: () => rootRouteImport,
} as any)
const AlbumRoute = AlbumRouteImport.update({
  id: '/album',
  path: '/album',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/album': typeof AlbumRoute
  '/linha-do-tempo': typeof LinhaDoTempoRoute
  '/manual': typeof ManualRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/album': typeof AlbumRoute
  '/linha-do-tempo': typeof LinhaDoTempoRoute
  '/manual': typeof ManualRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/album': typeof AlbumRoute
  '/linha-do-tempo': typeof LinhaDoTempoRoute
  '/manual': typeof ManualRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/album' | '/linha-do-tempo' | '/manual'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/album' | '/linha-do-tempo' | '/manual'
  id: '__root__' | '/' | '/album' | '/linha-do-tempo' | '/manual'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AlbumRoute: typeof AlbumRoute
  LinhaDoTempoRoute: typeof LinhaDoTempoRoute
  ManualRoute: typeof ManualRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/manual': {
      id: '/manual'
      path: '/manual'
      fullPath: '/manual'
      preLoaderRoute: typeof ManualRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/linha-do-tempo': {
      id: '/linha-do-tempo'
      path: '/linha-do-tempo'
      fullPath: '/linha-do-tempo'
      preLoaderRoute: typeof LinhaDoTempoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/album': {
      id: '/album'
      path: '/album'
      fullPath: '/album'
      preLoaderRoute: typeof AlbumRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AlbumRoute: AlbumRoute,
  LinhaDoTempoRoute: LinhaDoTempoRoute,
  ManualRoute: ManualRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

import type { getRouter } from './router.tsx'
import type { startInstance } from './start.ts'
declare module '@tanstack/react-start' {
  interface Register {
    ssr: true
    router: Awaited<ReturnType<typeof getRouter>>
    config: Awaited<ReturnType<typeof startInstance.getOptions>>
  }
}
